import { ReactNode } from 'react';

interface ClearableSelectProps {
  children: ReactNode;
  onClear: () => void;
  showClear?: boolean;
}

export function ClearableSelect({ children, onClear, showClear = true }: ClearableSelectProps) {
  return (
    <span className="relative">
      {children}
      {showClear && (
        <button
          onClick={onClear}
          className="absolute top-1.5 right-8 p-1 text-gray-500 duration-150 hover:text-gray-900"
          type="button"
        >
          <span className="iconify lucide--x"></span>
        </button>
      )}
    </span>
  );
}
